import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, ChevronRight } from 'lucide-react';
import { Button } from './Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Industries',
    path: '/industries'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-40 w-full" data-id="element-116" data-mp="3f9dle5knbzdv">
      {/* Top Bar */}
      <div className="hidden lg:block bg-gray-50 border-b border-gray-100 py-2" data-id="element-117" data-mp="2wirpdpzd2ps2">
        <div className="container-custom flex justify-between items-center text-sm text-gray-600" data-id="element-118" data-mp="2rk6pxsrxoa4o">
          <div className="flex items-center space-x-6" data-id="element-119" data-mp="2mn6pbxdurzky">
            <a href="tel:+971042766249" className="flex items-center hover:text-blue-800 transition-colors" data-id="element-120" data-mp="2ho3kacxvhtcz">
              <Phone className="h-3.5 w-3.5 mr-2" data-id="element-121" data-mp="3fakl3s5tep3h" />
              +971 04 276 6249
            </a>
            <a href="mailto:info@brixenconsulting.com" className="flex items-center hover:text-blue-800 transition-colors" data-id="element-122" data-mp="3ad11ecqclk45">
              <Mail className="h-3.5 w-3.5 mr-2" data-id="element-123" data-mp="30lemo6esx2wn" />
              info@brixenconsulting.com
            </a>
          </div>
          <div className="flex items-center space-x-4" data-id="element-124" data-mp="1y0kmewk5xvq">
            <span data-id="element-125" data-mp="3talgwt7836c3">Business Bay, Dubai, UAE</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className={`bg-white transition-all duration-300 ${isScrolled ? 'shadow-md py-3' : 'py-5 border-b border-gray-100'}`} data-id="element-126" data-mp="1remfyovtmait">
        <div className="container-custom flex items-center justify-between" data-id="element-127" data-mp="1weh5op3v0u2a">
          {/* Logo */}
          <Link to="/" className="flex items-center z-50" data-id="element-128" data-mp="1hlxfep1t6h29">
            <div className="flex flex-col" data-id="element-129" data-mp="1mljt0zljtzbl">
              <span className="text-2xl font-bold text-gray-950 tracking-tight leading-none" data-id="element-130" data-mp="18n3ckgxvwug9">
                Brixen
              </span>
              <span className="text-xs font-medium text-blue-800 tracking-widest uppercase mt-0.5" data-id="element-131" data-mp="1cpq8ou1l91j9">
                Consulting
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-132" data-mp="13os1y3zrmfwz">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-blue-800 ${location.pathname === link.path ? 'text-blue-800' : 'text-gray-600'}`} data-id="element-133" data-mp="2t3geq6c9pzvj">
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block" data-id="element-134" data-mp="w4zifg7uox4g">
            <Link to="/contact" data-id="element-135" data-mp="w5sm28bij6id">
              <Button size="sm" variant="primary" data-id="element-136" data-mp="re13ol2ig73b">
                Book Consultation
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-gray-600 hover:text-gray-900 z-50" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-137" data-mp="156z44ltt8pdq">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-138" data-mp="1a3pjf6xsjgy3" /> : <Menu className="h-6 w-6" data-id="element-139" data-mp="1a50p5casqyru" />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div className={`fixed inset-0 bg-white z-40 transform transition-transform duration-300 ease-in-out lg:hidden pt-24 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-140" data-mp="3bvlvchnveste">
        <div className="container-custom flex flex-col h-full pb-8" data-id="element-141" data-mp="27xrwii831379">
          <nav className="flex flex-col space-y-6 text-lg font-medium mb-8" data-id="element-142" data-mp="27vxaf0l2r51l">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`flex items-center justify-between py-2 border-b border-gray-50 ${location.pathname === link.path ? 'text-blue-800' : 'text-gray-900'}`} data-id="element-143" data-mp="2cv0gmocsjhb5">
                {link.name}
                <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-144" data-mp="1p565cb84e0t0" />
              </Link>)}
          </nav>

          <div className="mt-auto space-y-4" data-id="element-145" data-mp="1xzkgc1lmap6b">
            <Link to="/contact" className="block w-full" data-id="element-146" data-mp="1y0drrfviu2us">
              <Button fullWidth size="lg" data-id="element-147" data-mp="11hxz9r2vanpx">
                Book Consultation
              </Button>
            </Link>

            <div className="pt-6 border-t border-gray-100 space-y-3 text-sm text-gray-600" data-id="element-148" data-mp="15ihvmsfm9nb0">
              <a href="tel:+971042766249" className="flex items-center" data-id="element-149" data-mp="y0a8lztktxiz">
                <Phone className="h-4 w-4 mr-3 text-blue-800" data-id="element-150" data-mp="xxe94722z0sf" />
                +971 04 276 6249
              </a>
              <a href="mailto:info@brixenconsulting.com" className="flex items-center" data-id="element-151" data-mp="oyu05xmbo5he">
                <Mail className="h-4 w-4 mr-3 text-blue-800" data-id="element-152" data-mp="jz7kzimxof5y" />
                info@brixenconsulting.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>;
}